import { FormGroup } from '@angular/forms';

export function TriggerValidations(form: FormGroup): void {

    Object.keys(form.controls).forEach(field => {
        const control = form.get(field);
        control?.updateValueAndValidity();
    });
}
